import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-date-picker',
	templateUrl: './date-picker.component.html',
	styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() config: FormGroup;
	@Input() form: FormGroup;
	dateField: Date;
	timeField: Date;

	constructor(private fb: FormBuilder) {}

	ngOnInit() {
		const timestamp = this.package.defaultValue.timestamp;
		this.dateField = new Date(timestamp * 1000);
		this.timeField = new Date(timestamp * 1000);
	}

	hide(elem): void {
		elem.hide();
	}
}
